export default __webpack_public_path__ + "static/media/column_dots.62e24a64.svg";